var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isInitialLoading && _vm.aggregations)?_c('TableAggregationsToolbar',{attrs:{"aggregations":_vm.aggregations}}):_vm._e(),(_vm.isInitialLoading)?_c('b-skeleton',{attrs:{"width":"300px","height":"24px"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }